"use client";
import { ArtifactSidebar, ArtifactSidebarRef } from "@/component/artifact-sidebar";
import { createContext, PropsWithChildren, useRef, useState } from "react";

export const shareContext = createContext({
  code: "",
  setArtifact: (state: { code: string;  }) => {},
  open: () => {},
});

export const Context: React.FC<PropsWithChildren> = ({ children }) => {
  const artifactRef = useRef<ArtifactSidebarRef>(null);

  const [state, setArtifact] = useState({
    code: "",
  });

  const open = () => {
    artifactRef.current?.open();
  };

  return (
    <shareContext.Provider value={{ ...state, setArtifact, open }}>
      <ArtifactSidebar ref={artifactRef} code={state.code}>
        {children}
      </ArtifactSidebar>
    </shareContext.Provider>
  );
};
